import React, { useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const AnimatedNumber = ({ value, duration = 2, defaultStart = 0 }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Ensures animation runs only once
    threshold: 0.2, // Fires when 20% of the component is visible
  });

  const parsed = (() => {
    const match = value.toString().match(/([\d,.]+)(.*)/);
    if (!match) return null;

    const numeric = parseFloat(match[1].replace(/,/g, ""));
    return isNaN(numeric) ? null : { numeric, suffix: match[2] || "" };
  })();

  return (
    <span ref={ref}>
      {parsed ? (
        <CountUp start={defaultStart} end={inView ? parsed.numeric : defaultStart} duration={duration} suffix={parsed.suffix} />
      ) : (
        value
      )}
    </span>
  );
};

export default AnimatedNumber;
